import { render } from "./admin-robot-archives.vue?vue&type=template&id=7324fb2e&scoped=true"
import script from "./admin-robot-archives.vue?vue&type=script&lang=js"
export * from "./admin-robot-archives.vue?vue&type=script&lang=js"

import "./admin-robot-archives.vue?vue&type=style&index=0&id=7324fb2e&scoped=true&lang=css"

import exportComponent from "D:\\HbSave\\roc_web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7324fb2e"]])

export default __exports__